<template>
    <dl class="target-list">
        <dd
            v-for="(item, index) in targetInfo"
            :key="index"
            class="link"
            :class="[{ active: item.active }, index % 2 === 0 ? 'fl' : 'fr']"
            @click="toggleCard(index)"
        >
            <div v-show="!item.active"><img :src="getCardImgUrl(index)" :alt="getCardImgUrl(index)" /></div>
            <div v-show="item.active" class="desc-wrap" :style="{ backgroundColor: item.bgColor }">
                <p class="desc">{{ item.desc }}</p>
            </div>
        </dd>
    </dl>
</template>

<script>
export default {
    props: {
        targetData: { type: Array },
        pageName: { type: String }
    },
    data() {
        return {
            current: 0,
            targetInfo: []
        }
    },
    created() {
        this.targetInfo = this.targetData || []
    },
    methods: {
        getCardImgUrl(idx) {
            const { bgImg } = this.targetInfo[idx]
            return require(`@/assets/images/sustainable/${this.pageName}/${bgImg}`)
        },
        toggleCard(idx) {
            if (this.current === idx) {
                this.targetInfo[idx].active = !this.targetInfo[idx].active
            } else {
                this.targetInfo[this.current].active = false
                this.targetInfo[idx].active = true
                this.current = idx
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../common.scss';
.target-list {
    margin-top: 0.2rem;
    overflow: hidden;
    dd {
        display: inline-block;
        width: 2.8rem;
        margin-bottom: 0.4rem;
        height: 2.8rem;
        transition: height 0.3s ease-in-out;
        .desc {
            font-size: 0.27rem;
            line-height: 1.65;
            text-align: left;
            color: #ffffff;
            height: 100%;
            overflow: hidden;
            text-align: justify;
        }
        &.active {
            &.fl {
                float: left;
                margin-right: 0.445rem;
            }
            &.fr {
                float: right;
                margin-left: 0.445rem;
            }
            height: 5.99rem;
            .desc-wrap {
                height: 100%;
                padding: 0.2rem;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/sustainable/components/targetList.vue